export default __webpack_public_path__ + "static/media/xoog.8b225587.svg";